import {
  ADDRESS_REGEX,
  POSTAL_CODE_REGEX,
  validEmptyText,
  validSearchInput,
  validGoogleMapsInput,
} from '@/utils/validators';
import { PROVINCES } from './provinces';

export const BILLING_ADDRESS = {
  ID: 'street-address',
  TITLE: 'Dirección de facturación',
  HORIZONTAL_ADDRESS: {
    ID: 'horizontal-address',
    NAME: 'street-address',
    LABEL: 'Calle, número, localidad, código postal',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      VALIDATE: {
        REQUIRED: {
          checkFunc: validSearchInput,
          message: 'Campo obligatorio',
        },
      },
    },
  },
  VERTICAL_ADDRESS: {
    ID: 'vertical-address',
    NAME: 'vertical-address',
    LABEL: 'Escalera, planta, puerta',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      VALIDATE: {
        REQUIRED: {
          checkFunc: validSearchInput,
          message: 'Campo obligatorio',
        },
      },
    },
  },
  MANUAL_ADDRESS_CHECKBOX: {
    ID: 'manual-address-checkbox',
    NAME: 'manual-address-checkbox',
    LABEL: 'No encuentro mi dirección',
  },
  ADDRESS: {
    ID: 'address',
    NAME: 'address',
    LABEL: 'Calle, número, localidad',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        ADDRESS_FORMAT: {
          value: ADDRESS_REGEX,
          message: 'Campo no válido',
        },
      },
      VALIDATE: {
        REQUIRED: {
          checkFunc: validGoogleMapsInput,
          message: 'Campo obligatorio',
        },
      },
    },
  },
  POSTAL_CODE: {
    ID: 'postal-code',
    NAME: 'postal-code',
    LABEL: 'Código postal',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        ADDRESS_FORMAT: {
          value: POSTAL_CODE_REGEX,
          message: 'Campo no válido',
        },
      },
    },
  },
  ADDRESS_DETAIL: {
    ID: 'address-detail',
    NAME: 'address-level2',
    LABEL: 'Escalera, planta, puerta',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        ADDRESS_FORMAT: {
          value: ADDRESS_REGEX,
          message: 'Campo no válido',
        },
      },
    },
  },
  STREET_NUMBER: {
    ID: 'street-number',
    NAME: 'street-number',
    LABEL: 'Número',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        ADDRESS_FORMAT: {
          value: ADDRESS_REGEX,
          message: 'Campo no válido',
        },
      },
    },
  },
  FLOOR: {
    ID: 'floor',
    NAME: 'floor',
    LABEL: 'Planta',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        ADDRESS_FORMAT: {
          value: ADDRESS_REGEX,
          message: 'Campo no válido',
        },
      },
    },
  },
  DOOR: {
    ID: 'door',
    NAME: 'door',
    LABEL: 'Puerta',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        ADDRESS_FORMAT: {
          value: ADDRESS_REGEX,
          message: 'Campo no válido',
        },
      },
    },
  },
  PROVINCE: {
    ID: 'address-province',
    NAME: 'province',
    LABEL: 'Provincia',
    RULES: {
      REQUIRED: 'Campo obligatorio',
    },
    OPTIONS: PROVINCES,
    DEFAULT_VALUE: { label: 'Elige tu opción' },
  },
};
